import { Type } from "@sinclair/typebox";

export const WorkforceRouteSimulateParamsSchema = Type.Object(
  {
    channelId: Type.String({ minLength: 1 }),
    messageType: Type.Union([
      Type.Literal("dm"),
      Type.Literal("group"),
      Type.Literal("channel"),
      Type.Literal("webhook"),
    ]),
    content: Type.Optional(Type.String()),
    requiredSkills: Type.Optional(Type.Array(Type.String())),
    teamId: Type.Optional(Type.String()),
    customerTier: Type.Optional(Type.String()),
    accountId: Type.Optional(Type.String()),
    userId: Type.Optional(Type.String()),
    guildId: Type.Optional(Type.String()),
  },
  { additionalProperties: false },
);

export const WorkforceInsightsParamsSchema = Type.Object({}, { additionalProperties: false });

export const WorkforceFleetStatusParamsSchema = Type.Object({}, { additionalProperties: false });

export const WorkforceFleetRouteParamsSchema = Type.Object(
  {
    requiredSkills: Type.Optional(Type.Array(Type.String())),
    preferredAgentId: Type.Optional(Type.String()),
    candidates: Type.Optional(Type.Array(Type.String())),
  },
  { additionalProperties: false },
);

export const WorkforceAgentLoadParamsSchema = Type.Object(
  {
    agentId: Type.String({ minLength: 1 }),
  },
  { additionalProperties: false },
);
